export const Required = value => {
    return value === null || value === undefined || (Array.isArray(value) && value.length == 0) ? 'This field is required' : undefined;
}

export const RequiredNotBlank = value => {
    return value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
        ? 'This field is required'
        : undefined;
}
